import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { errorUrlTree, guardRoundTrip } from '@mkp/shared/util-guards';
import {
  applicationApiActions,
  applicationExistGuardActions,
} from '@mkp/application/state/actions';
import { QUERY_PARAMS_ID } from '@mkp/shared/util-router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, merge, of } from 'rxjs';

export const applicationExistGuard: CanActivateFn = (route) => {
  const actions$ = inject(Actions);
  const store = inject(Store);
  const router = inject(Router);

  const id = route.queryParams[QUERY_PARAMS_ID];
  const notFound = () => errorUrlTree(router, 404);

  return id
    ? guardRoundTrip({
        guardName: 'applicationExistGuard',
        dispatchRequest: () => store.dispatch(applicationExistGuardActions.canActivate({ id })),
        outcome$: merge(
          actions$.pipe(ofType(applicationApiActions.routeApplicationLoadedSuccess)),
          actions$.pipe(
            ofType(applicationApiActions.routeApplicationLoadedFailure),
            map(() => notFound())
          )
        ),
        onTimeout: notFound,
      })
    : of(true);
};
